import React, { useState } from "react";
import "./styles.scss";
import LogoIcon from "../../../Components/Icon-SVG/LogoIcon";
import PricePopup from "../../CloudCommon/PricePopup/PricePopup";
import { Link } from "react-router-dom";

const CloudFooter = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContentType, setPopupContentType] = useState("");

  const handleLinkClick = (contentType) => {
    setPopupContentType(contentType);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContentType("");
  };

  return (
    <div className="footer-cl">
      <div className="footer-cl__inner">
        <a href="#" className="footer-cl__inner__link">
          <Link
            to="/pricing"
            title="Princing"
            className="header__nav-item"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "var(--color-blue)",
            }}>
            Pricing
          </Link>
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          href="#"
          className="footer-cl__inner__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("privacy");
          }}>
          Privacy Policy
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          href="#"
          className="footer-cl__inner__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("agreement");
          }}>
          Distance Sales Agreement
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          href="#"
          className="footer-cl__inner__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("delivery");
          }}>
          Delivery and Refund Terms
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          href="#"
          className="footer-cl__inner__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("terms");
          }}>
          Terms of Service
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a className="footer-cl__inner__link" href="https://cyber-fortress.com/main/about.html">
          About Us
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          href="#"
          className="footer-cl__inner__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("contact");
          }}>
          Contact US
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <a
          className="footer-cl__inner__link"
          href="https://cyber-fortress.com/"
          target="_blank"
          rel="noreferrer">
          <div className="footer-cl__logo">
            <div className="footer-cl__logo__icon" style={{ marginTop: "5px" }}>
              <LogoIcon width={33} height={33} color="#1082b4" />
            </div>
            <div className="footer-cl__logo__text">
              <strong className="footer-cl__logo__text-cyber">Cyber</strong>
              <strong className="footer-cl__logo__text-fortress">Fortress</strong>
            </div>
          </div>
        </a>
        <span className="footer-cl__inner__pipe"> | </span>
        <p className="footer-cl__inner__text">Security Professionals</p>
      </div>

      <PricePopup isOpen={isPopupOpen} onClose={closePopup} contentType={popupContentType} />
    </div>
  );
};

export default CloudFooter;
